import moment from "moment"

export function formatMoment(value, format) {
  return moment(value).format(format)
}

export function checkMoment(value) {
  return moment(value).isValid()
}